import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout';

Vue.component(CollapseTransition.name, CollapseTransition);
Vue.use(Router);
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/do',
    component: () => import('@/views/login/auto-login'),
    hidden: true
  },
  {
    path: '/go',
    component: () => import('@/views/login/auto-go'),
    hidden: true
  },
  {
    path: '/company/info',
    component: () => import('@/views/company/detail'),
    name: 'CompanyInfo',
    hidden: true,
    meta: { title: '企业详情' }
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/index',
    hidden: true,
    meta: { title: '个人中心' },
    children: [
      {
        path: '/user/index',
        component: () => import('@/views/user/index'),
        redirect: '/user/index/userpage',
        meta: { title: '个人中心' },
        children: [
          {
            path: '/user/index/userpage',
            component: () => import('@/views/user/userpage'),
            name: 'userPage',
            meta: { title: '个人主页' }
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    code: 'ComprehensiveSearch',
    meta: { title: '综合检索', isSingle: true },
    children: [
      {
        path: '/index',
        component: () => import('@/views/index/index'),
        name: 'Index',
        hidden: true
      },
      {
        path: '/index/search',
        component: () => import('@/views/index/search'),
        name: 'IndexSearch',
        hidden: true,
        meta: { title: '综合检索', activeMenu: '/index' }
      }
    ]
  },
  {
    path: '/company',
    component: Layout,
    redirect: '/company/index',
    code: 'TechnologicalEnterprise',
    meta: { title: '科技企业' },
    children: [
      {
        path: '/company/index',
        component: () => import('@/views/company/index'),
        name: 'CompanyIndex',
        code: 'CompanySearch',
        meta: { title: '企业检索' }
      },
      {
        path: '/company/merge/index',
        component: () => import('@/views/merge/index'),
        name: 'CompanyMergeIndex',
        code: 'CompanyMerge',
        meta: { title: '合并分析' }
      },
      {
        path: '/theme/index',
        component: () => import('@/views/theme/index'),
        redirect: '/theme/top',
        name: 'ThemeIndex',
        code: 'CompanyLibrary',
        meta: { title: '企业主题库' },
        children: [
          {
            path: '/theme/top',
            component: () => import('@/views/theme/top'),
            name: 'ThemeTop',
            meta: { title: '企业榜单', activeMenu: '/theme/index' }
          },
          {
            path: '/theme/identification',
            component: () => import('@/views/theme/identification'),
            name: 'ThemeIdentification',
            meta: { title: '特色资质企业', activeMenu: '/theme/index' }
          },
          {
            path: '/theme/companyList',
            component: () => import('@/views/theme/newCompanyList'),
            name: 'ThemeCompanyList',
            meta: { title: '企业库企业列表', activeMenu: '/theme/index', hidden: true, activeMenus: '/theme/identification' }
          }
        ]
      },
      {
        path: '/company/list',
        component: () => import('@/views/company/list'),
        name: 'CompanyList',
        hidden: true,
        meta: { title: '企业列表', activeMenu: '/company/index' }
      },
      {
        path: '/company/highSearch',
        component: () => import('@/views/company/highSearch'),
        name: 'CompanyHighSearch',
        hidden: true,
        meta: { title: '企业高级检索', activeMenu: '/company/index' }
      },
      {
        path: '/company/detail',
        component: () => import('@/views/company/detail'),
        name: 'CompanyDetail',
        hidden: true,
        meta: { title: '企业详情' }
      },
      {
        path: '/company/guquan',
        component: () => import('@/views/company/guquan'),
        name: 'CompanyGuquan',
        hidden: true,
        meta: { title: '企业股权结构' }
      },
      {
        path: '/company/industry',
        component: () => import('@/views/company/industry/index'),
        name: 'CompanyIndustry',
        hidden: true,
        meta: { title: '全部行业评价' }
      },
      {
        path: '/company/soft',
        component: () => import('@/views/company/soft'),
        name: 'CompanySoft',
        hidden: true,
        meta: { title: '企业软著查看' }
      },
      {
        path: '/company/patent',
        component: () => import('@/views/company/patent'),
        name: 'CompanyPatent',
        hidden: true,
        meta: { title: '企业专利查看' }
      },
      {
        path: '/company/contrast',
        component: () => import('@/views/company/contrast'),
        name: 'CompanyContrast',
        hidden: true,
        meta: { title: '企业对比' }
      },
      {
        path: '/company/merge/addData',
        component: () => import('@/views/merge/addData'),
        name: 'MergeAddData',
        hidden: true,
        meta: { title: '合并分析-添加' }
      },
      {
        path: '/company/merge',
        component: () => import('@/views/merge/overallAnalysis'),
        name: 'OverallAnalysis',
        hidden: true,
        meta: { title: '整体合并' }
      },
      {
        path: '/company/merge/industry',
        component: () => import('@/views/merge/industry/index'),
        name: 'MergeIndustry',
        hidden: true,
        meta: { title: '合并 - 行业评价' }
      },
      {
        path: '/company/merge/patents',
        component: () => import('@/views/merge/patents'),
        name: 'MergePatents',
        hidden: true,
        meta: { title: '专利列表' }
      },
      {
        path: '/company/merge/software',
        component: () => import('@/views/merge/softWare'),
        name: 'MergeSoftware',
        hidden: true,
        meta: { title: '软著列表' }
      }
    ]
  },
  {
    path: '/industrialCenter',
    component: Layout,
    redirect: '/industry/normal',
    code: 'IndustryCenter',
    meta: { title: '产业中心' },
    children: [
      {
        path: '/industry/chain',
        component: () => import('@/views/industry/chain'),
        // redirect: '/industry/chain/index',
        code: 'IndustryChain',
        name: 'IndustryChain',
        meta: { title: '主题产业链' }
      },
      {
        path: '/industry/chain/index',
        component: () => import('@/views/industry/chainIndex'),
        name: 'IndustryChainIndex',
        hidden: true,
        meta: { title: '产业链概览', activeMenu: '/industry/chain' }
      },
      {
        path: '/industry/chain/detail',
        component: () => import('@/views/industry/chainDetail'),
        name: 'IndustryChainDetail',
        hidden: true,
        meta: { title: '产业链概览', activeMenu: '/industry/chain' }
      },
      {
        path: '/industry/chain/list',
        component: () => import('@/views/industry/chainList'),
        name: 'ChainCompanyList',
        hidden: true,
        meta: { title: '产业链企业列表', activeMenu: '/industry/chain' }
      },
      {
        path: '/industry/index',
        component: () => import('@/views/industry/index'),
        name: 'IndustryIndex',
        code: 'IndustryMap',
        meta: { title: '行业图谱' }
      },
      {
        path: '/industry/list/:industryId',
        component: () => import('@/views/industry/list'),
        name: 'IndustryList',
        hidden: true,
        meta: { title: '行业图谱-企业列表', activeMenu: '/industry/index' }
      },
      {
        path: '/industry/normal',
        component: () => import('@/views/industry/normal'),
        name: 'IndustryNormal',
        code: 'IndustrySearch',
        meta: { title: '行业检索' }
      },
      {
        path: '/industry/search',
        component: () => import('@/views/industry/search'),
        name: 'IndustrySearch',
        hidden: true,
        meta: { title: '行业列表', activeMenu: '/industry/normal' }
      },
      {
        path: '/industry/highSearch',
        component: () => import('@/views/industry/highSearch'),
        name: 'IndustryHighSearch',
        hidden: true,
        meta: { title: '行业高级检索', activeMenu: '/industry/normal' }
      },
      {
        path: '/regionalmap/index',
        component: () => import('@/views/regionalmap/index'),
        name: 'RegionalMapIndex',
        code: 'AreaMap',
        meta: { title: '区域分析' }
      },
      {
        path: '/regionalmap/contrast',
        component: () => import('@/views/regionalmap/contrast'),
        name: 'RegionalMapContrast',
        hidden: true,
        meta: { title: '区域分析-对比', activeMenu: '/regionalmap/index' }
      },
      {
        path: '/regionalmap/list',
        component: () => import('@/views/regionalmap/newList'),
        name: 'RegionalMapList',
        hidden: true,
        meta: { title: '区域分析-企业列表', activeMenu: '/regionalmap/index' }
      }
    ]
  },
  {
    path: '/innovate',
    component: Layout,
    redirect: '/patent/index',
    code: 'InnovationEvaluation',
    meta: { title: '创新评估' },
    children: [
      {
        path: '/patent/index',
        component: () => import('@/views/innovate/patent/index'),
        name: 'PatentIndex',
        code: 'TechnicalEvaluation',
        meta: { title: '技术评估' }
      },
      {
        path: '/patent/list',
        component: () => import('@/views/innovate/patent/list'),
        name: 'PatentList',
        hidden: true,
        meta: { title: '专利列表', activeMenu: '/patent/index' }
      },
      {
        path: '/patent/highSearch',
        component: () => import('@/views/innovate/patent/highSearch'),
        name: 'PatentHighSearch',
        hidden: true,
        meta: { title: '专利高级检索', activeMenu: '/patent/index' }
      },
      {
        path: '/talent/index',
        component: () => import('@/views/innovate/talent/index'),
        name: 'TalentIndex',
        code: 'Talent',
        meta: { title: '人才画像' }
      },
      {
        path: '/talent/list',
        component: () => import('@/views/innovate/talent/list'),
        name: 'TalentList',
        hidden: true,
        meta: { title: '人才列表', activeMenu: '/talent/index' }
      },
      {
        path: '/talent/highSearch',
        component: () => import('@/views/innovate/talent/highSearch'),
        name: 'TalentHighSearch',
        hidden: true,
        meta: { title: '人才高级检索', activeMenu: '/talent/index' }
      },
      {
        path: '/talent/detail',
        component: () => import('@/views/innovate/talent/detail'),
        name: 'TalentDetail',
        hidden: true,
        meta: { title: '人才详情', activeMenu: '/talent/index' }
      },
      {
        path: '/talent/patent',
        component: () => import('@/views/innovate/talent/patent'),
        name: 'TalentPatent',
        hidden: true,
        meta: { title: '人才详情-全部专利', activeMenu: '/talent/index' }
      },
      {
        path: '/paper/index',
        component: () => import('@/views/innovate/paper/index'),
        name: 'PaperIndex',
        code: 'PaperSearch',
        meta: { title: '论文检索' }
      },
      {
        path: '/paper/list',
        component: () => import('@/views/innovate/paper/list'),
        name: 'PaperList',
        hidden: true,
        meta: { title: '论文列表', activeMenu: '/paper/index' }
      },
      {
        path: '/paper/highSearch',
        component: () => import('@/views/innovate/paper/highSearch'),
        name: 'PaperHighSearch',
        hidden: true,
        meta: { title: '论文高级检索', activeMenu: '/paper/index' }
      },
      {
        path: '/paper/detail',
        component: () => import('@/views/innovate/paper/detail'),
        name: 'PaperDetail',
        hidden: true,
        meta: { title: '论文详情', activeMenu: '/paper/index' }
      },
      {
        path: '/patent/detail',
        component: () => import('@/views/innovate/patent/detail'),
        name: 'PatentDetail',
        hidden: true,
        meta: { title: '专利详情', activeMenu: '/patent/index' }
      },
      {
        path: '/patent/base',
        component: () => import('@/views/innovate/patent/base'),
        name: 'PatentBase',
        hidden: true,
        meta: { title: '专利基本信息', activeMenu: '/patent/index' }
      }
    ]
  },
  {
    path: '/workbench',
    component: Layout,
    redirect: '/workbench/index',
    code: 'MyWorkbench',
    meta: { title: '我的工作台' },
    children: [
      {
        path: '/workbench/index',
        component: () => import('@/views/workbench/index'),
        redirect: '/workbench/list',
        meta: { title: '我的工作台' },
        children: [
          // {
          //   path: '/workbench/statistics',
          //   component: () => import('@/views/workbench/statistics'),
          //   name: 'WorkbenchIndex',
          //   redirect: '/workbench/list',
          //   meta: { title: '统计', activeMenu: '/workbench/index' }
          // },
          {
            path: '/workbench/list',
            component: () => import('@/views/workbench/list'),
            name: 'WorkbenchList',
            meta: { title: '监测列表', activeMenu: '/workbench/index' }
          },
          {
            path: '/message/list',
            component: () => import('@/views/workbench/message/index'),
            name: 'messageList',
            meta: { title: '消息中心', activeMenu: '/workbench/index' }
          },
          {
            path: '/message/detail',
            component: () => import('@/views/workbench/message/detail'),
            name: 'messageDetail',
            hidden: true,
            meta: {title: '消息详情', activeMenu: '/workbench/index'}
          },
          {
            path: '/task/list',
            component: () => import('@/views/workbench/message/task'),
            name: 'taskList',
            meta: { title: '任务中心', activeMenu: '/workbench/index' }
          }
        ]
      }
    ]
  },
  {
    path: '/hotTool',
    component: Layout,
    redirect: '/hotTool/attractInvestmentMap',
    code: 'Tools',
    meta: { title: '热门工具', isSingle: true },
    children: [
      // {
      //   path: '/hotTool/attractInvestmentMap',
      //   component: () => import('@/views/hotTool/attractInvestmentMap/index'),
      //   name: 'AttractInvestmentMap',
      //   code: 'MapAttractInvestment',
      //   meta: { title: '地图招商' }
      // },
      {
        path: '/hotTool/investIndex',
        component: () => import('@/views/hotTool/invest/index'),
        name: 'investIndex',
        code: 'InvestmentOverview',
        meta: { title: '投资总览' }
      },
      {
        path: '/hotTool/indexList',
        component: () => import('@/views/hotTool/invest/indexList'),
        name: 'investList',
        hidden: true,
        meta: { title: '企业列表', activeMenu: '/hotTool/investIndex' }
      },
      {
        path: '/hotTool/financing',
        component: () => import('@/views/hotTool/invest/financing'),
        name: 'investFinancing',
        code: 'FinancingLibrary',
        meta: { title: '投融资事件库' }
      },
      {
        path: '/hotTool/listed',
        component: () => import('@/views/hotTool/invest/listed'),
        name: 'investListed',
        code: 'ListedLibrary',
        meta: { title: '上市事件库' }
      },
      {
        path: '/hotTool/emigration',
        component: () => import('@/views/hotTool/emigration/index'),
        name: 'EmigrationIndex',
        code: 'MigrationWarning',
        meta: { title: '外迁预警' }
      },
      {
        path: '/hotTool/chainSearch',
        component: () => import('@/views/hotTool/chainSearch/index'),
        name: 'ChainSearchIndex',
        code: 'ChainSearch',
        meta: { title: '链式寻企' }
      },
      {
        path: '/hotTool/network',
        component: () => import('@/views/hotTool/network/index'),
        name: 'NetworkIndex',
        code: 'CompanyRelationship',
        meta: { title: '企业关系网络' }
      }
    ]
  },
  // {
  //   path: '/techindustry',
  //   component: () => import('@/views/techindustry/index'),
  //   meta: { title: '决策中枢' },
  //   redirect: '/techindustry/index/industrialEconomy/index',
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/techindustry/index1'),
  //       redirect: '/techindustry/index/industrialEconomy/index',
  //       meta: { title: '决策中枢' },
  //       children: [
  //         {
  //           path: 'industrialEconomy/index',
  //           component: () => import('@/views/techindustry/industrial-economy/index'),
  //           name: 'IndustrialEconomyIndex',
  //           meta: { title: '区域产业经济' }
  //         },
  //         {
  //           path: 'IndustryPlan/index',
  //           component: () => import('@/views/techindustry/industry-plan/index'),
  //           name: 'IndustryPlanIndex',
  //           meta: { title: '重点产业规划' }
  //         },
  //         {
  //           path: 'IndustryPlan/beijing',
  //           component: () => import('@/views/techindustry/industry-plan/beijing'),
  //           name: 'IndustryPlanBeijing',
  //           meta: { title: '重点产业规划-北京' }
  //         },
  //         {
  //           path: 'IndustryPlan/china',
  //           component: () => import('@/views/techindustry/industry-plan/china'),
  //           name: 'IndustryPlanChina',
  //           meta: { title: '重点产业规划-全国' }
  //         },
  //         {
  //           path: 'attractInvestment/index',
  //           component: () => import('@/views/techindustry/attractInvestment/index'),
  //           name: 'attractInvestmentIndex',
  //           meta: { title: '园区画像' }
  //         },
  //         {
  //           path: 'areaContrast/index',
  //           component: () => import('@/views/techindustry/area-contrast/index'),
  //           name: 'AreaContrastIndex',
  //           meta: { title: '选择区域' }
  //         },
  //         {
  //           path: 'areaContrast/contrast',
  //           component: () => import('@/views/techindustry/area-contrast/contrast'),
  //           name: 'AreaContrastContrast',
  //           meta: { title: '区域对比' }
  //         },
  //         {
  //           path: 'teccompany/list',
  //           component: () => import('@/views/techindustry/company/list'),
  //           name: 'techindustryCompanyList',
  //           meta: { title: '企业列表' }
  //         },
  //         {
  //           path: 'teccompany/detail',
  //           component: () => import('@/views/techindustry/company/detail'),
  //           name: 'techindustryCompanyDetail',
  //           meta: { title: '企业详情' }
  //         },
  //         {
  //           path: 'teccompany/industry',
  //           component: () => import('@/views/techindustry/company/industry'),
  //           name: 'techindustryCompanyIndustry',
  //           meta: { title: '行业评价' }
  //         },
  //         {
  //           path: 'industrial/diagnosis',
  //           component: () => import('@/views/techindustry/industrial-diagnosis/index'),
  //           name: 'IndustrialDiagnosis',
  //           meta: { title: '产业诊断' }
  //         },
  //         {
  //           path: 'industrial/chain',
  //           component: () => import('@/views/techindustry/chain/index'),
  //           name: 'IndustrialChain',
  //           meta: { title: '产业图谱' }
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    path: '/application',
    component: () => import('@/views/application/index'),
    hidden: true
  }
];

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});

const router = createRouter();

export function resetRouter () {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js